<div class="div">
  <div class="div-6">
    <img
      loading="lazy"
      src="assets/images/launch-page-header.png"
      class="img-3"
    />
    <h1 id="welcome-heading">
      Welcome
      <span *ngIf="user !== null"
        >, {{ user?.['contact-info']?.name?.split(' ')[0] }}</span
      >
    </h1>
  </div>
  <div class="div-8">
    <div class="div-9">
      <div class="column" *ngIf="hasAccessToRailcarSearch">
        <div class="div-10">
          <img loading="lazy" src="/assets/img/layer-1.svg" class="img-4" />
          <div class="div-11">
            <div class="div-12">
              <div class="div-13 tile-heading">Railcar Search</div>
              <div class="div-14">
                Search Trinity's inventory to identify railcars that best suit
                your needs
              </div>
            </div>
            <div class="div-15 tile-btn">
              <div
                class="div-16"
                id="button-launch-railcar-search"
                (click)="navigateToDashboard()"
              >
                launch
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="column-3"
        [ngClass]="{ 'shift-left': !hasAccessToRailcarSearch }"
      >
        <div class="div-23">
          <img loading="lazy" src="/assets/img/layer-1-2.svg" class="img-6" />
          <div class="div-24">
            <div class="div-25">
              <div class="div-26">
                <div class="div-27 tile-heading">Railcar Marketplace</div>
                <div class="div-28">
                  Harness the potential of data to streamline your rail
                  performance.
                </div>
              </div>
            </div>
            <div class="div-29 tile-btn" id="coming-soon-gps-marketplace">
              coming soon
            </div>
          </div>
        </div>
      </div>
      <div
        class="column-2"
        [ngClass]="{ 'shift-left': !hasAccessToRailcarSearch }"
      >
        <div class="div-17">
          <img loading="lazy" src="/assets/img/layer-1-1.svg" class="img-5" />
          <div class="div-18">
            <div class="div-19">
              <div class="div-20 tile-heading">Rail Network Performance</div>
              <div class="div-21">
                Boost your logistics and unleash the power of your rail system.
              </div>
            </div>
            <div class="div-15 tile-btn" *ngIf="hasAccessToForecastAndDemand">
              <div
                class="div-16"
                id="button-launch-railcar-performance"
                (click)="navigateToRailPerformance()"
              >
                launch
              </div>
            </div>
            <!-- <div
              *ngIf="hasAccessToRailPerformance"
              class="div-29"
              id="coming-soon-gps-marketplace1"
            >
              coming soon
            </div>-->
            <div
              class="div-29 request-access"
              id="coming-soon-gps-marketplac"
              *ngIf="!hasAccessToRailPerformance"
              (click)="showLoginModal('Rail Performance')"
            >
              Request access
            </div>
          </div>
        </div>
      </div>
      <div
        class="column-2"
        [ngClass]="{ 'shift-left': !hasAccessToRailcarSearch }"
      >
        <div class="div-17">
          <svg
            class="img-5"
            width="131"
            height="130"
            viewBox="0 0 131 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M98.375 101V65H74.375V101H62.375V53H38.375V101H29.375V23H23.375V101C23.375 102.591 24.0071 104.117 25.1324 105.243C26.2576 106.368 27.7837 107 29.375 107H107.375V101H98.375ZM56.375 101H44.375V59H56.375V101ZM92.375 101H80.375V71H92.375V101Z"
              fill="#7A939C"
            />
            <path
              d="M85.7329 58.9997C84.4599 58.999 83.2202 58.5935 82.1929 57.8417L50.9899 34.9607L42.1009 46.9997L37.2859 43.4177L46.2319 31.4177C47.163 30.1666 48.5448 29.3272 50.0842 29.0775C51.6237 28.8277 53.1999 29.1872 54.4789 30.0797L85.7419 52.9997L96.5569 38.4197L101.375 41.9897L90.5629 56.5757C90.0035 57.3294 89.2751 57.9413 88.4362 58.3623C87.5974 58.7833 86.6715 59.0016 85.7329 58.9997Z"
              fill="#7A939C"
            />
          </svg>
          <div class="div-18">
            <div class="div-19">
              <div class="div-20 tile-heading">Forecast & Demand</div>
              <div class="div-21">
                Manage rail forecasts while tracking shipment performance and
                accuracy.
              </div>
            </div>
            <div class="div-15 tile-btn" *ngIf="hasAccessToForecastAndDemand">
              <div
                class="div-16"
                *ngIf="hasAccessToForecastAndDemand"
                id="button-launch-railcar-performance1"
                (click)="navigateToRailPerformanceForecast()"
              >
                launch
              </div>
            </div>
            <div
              class="div-29 request-access"
              id="coming-soon-gps-marketplace-for"
              *ngIf="!hasAccessToForecastAndDemand"
              (click)="showLoginModal('Forecast and Demand')"
            >
              Request access
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="div-30">
    <div class="div-31">
      <div class="div-32">
        <div class="div-33">
          <div class="div-34">Can’t find what you are looking for?</div>
          <div class="div-35">
            Connect with our team of experts, ready to assist with insights and
            answers tailored just for you.
          </div>
        </div>
        <div
          class="div-36"
          id="contact-button"
          onclick="window.open('https://www.trinityrail.com/contact/', '_blank');"
        >
          <div class="div-37">contact us</div>
        </div>
      </div>
    </div>
  </div>
</div>
